import isDateOriginal from 'date-fns/isDate';

const isDate = (val: unknown): val is Date | number => isDateOriginal(val);

export default isDate;
